export default "__VITE_ASSET__BfVKRqn9__"